<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">
                        <span *ngIf="serviceRequestService.statusForChange == 'closed'">Close</span>
                        <span *ngIf="serviceRequestService.statusForChange == 'cancelled'">Cancel</span>
                        <span *ngIf="serviceRequestService.statusForChange == 'archived'">Archive</span>
                        <span *ngIf="serviceRequestService.statusForChange == 'in_progress' &&
                                     !serviceRequestService.showAssignToModal">
                            Resume
                        </span>
                        <span *ngIf="serviceRequestService.statusForChange == 'in_progress' &&
                                     serviceRequestService.showAssignToModal">
                            Assign
                        </span>
                        <span *ngIf="serviceRequestService.statusForChange == 'on_hold'">On Hold</span>
                        <span *ngIf="serviceRequestService.statusForChange == 'open'">Open</span>
                        <span *ngIf="serviceRequestService.showAddCommentModal
                                     && serviceRequestService.isReadStatusForChange == -1
                                     && !serviceRequestService.statusForChange">
                            Comment
                        </span>
                        <span *ngIf="serviceRequestService.isReadStatusForChange != -1">Mark</span>
                        Service Request
                        <span *ngIf="serviceRequestService.isReadStatusForChange === 1">As Read</span>
                        <span *ngIf="serviceRequestService.isReadStatusForChange === 0">As Unread</span>
                    </h4>
                </div>
                <div class="modal-body">
                    <div *ngIf="serviceRequestService.showAssignToModal">
                        <div *ngIf="directoryService.account.canRead('vendors_directory')" class="assignee-type row m-b-sm">
                            <div class="col-md-4">
                                <label>Assignee</label>
                            </div>
                            <div class="col-md-4">
                                <div class="radio-box">
                                    <input id="assignStaff" type="radio"
                                           name="assigneeType"
                                           [value]="assigneeType.staff"
                                           [(ngModel)]="selectedAssigneeType"
                                           (ngModelChange)="assigneeTypeChange()">
                                    <label for="assignStaff" class="m-t-xs m-l-xs">Staff</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="radio-box">
                                    <input id="assignVendor" type="radio"
                                           name="assigneeType"
                                           [value]="assigneeType.vendor"
                                           [(ngModel)]="selectedAssigneeType"
                                           (ngModelChange)="data.assigneeEmail = ''; commentObj.isPublic = true">
                                    <label for="assignVendor" class="m-t-xs m-l-xs">Vendor</label>
                                </div>
                            </div>
                        </div>
                        <!-- ___ Assign To ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Assign To</label>
                            </div>
                            <div *ngIf="selectedAssigneeType === assigneeType.staff" class="col-md-8">
                                <select class="form-control"
                                        ngModel
                                        name="assignTo"
                                        #assignTo
                                        required
                                        (change)="changeAssignee($event)"
                                        [disabled]="!staffList.length">
                                    <option value="" hidden></option>
                                    <option *ngFor="let staff of staffList" [value]="staff.id">
                                        {{staff.fullName}}
                                    </option>
                                    <option value="0">Other</option>
                                </select>
                                <input *ngIf="assignTo.value == '0'"
                                       class="form-control"
                                       placeholder="Other Worker Name"
                                       [ngModel]="data.serviceRequestWorkerContractOther"
                                       name="otherWorker"
                                       maxlength="255" required>
                                <spinner [spinnerShow]="!staffList.length"></spinner>
                            </div>
                            <div *ngIf="selectedAssigneeType === assigneeType.vendor" class="col-md-8">
                                <vendor-select (vendorChanged)="vendorChanged($event)"></vendor-select>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Assignee Email</label>
                            </div>
                            <div class="col-md-8">
                                <input class="form-control"
                                       [ngModel]="data.assigneeEmail"
                                       type="email"
                                       pattern="[a-z0-9._%+-_]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                       name="assigneeEmail"
                                       maxlength="255" required>
                            </div>
                        </div>
                    </div>
                    <!-- ___ Comments  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Comments</label>
                        </div>
                        <div class="col-md-12">
                            <textarea [(ngModel)]="commentObj.comment"
                                      [ngClass]="{'internal' : commentObj.isPrivate && !commentObj.isPublic}"
                                      name="comment"
                                      class="form-control comment-input">
                            </textarea>
                        </div>
                    </div>

                    <div class="row m-b-sm comment-visibility-row" *ngIf="!authService.userIsResident">
                        <div class="col-md-12">
                            <label class="img-checkbox">
                                <input type="checkbox" checked disabled>
                                <label for="isPrivate"><svg-checked></svg-checked></label>
                                <span>Visible To Staff</span>
                            </label>
                        </div>
                        <div class="col-md-12">
                            <label class="img-checkbox">
                                <input [ngModel]="!commentObj.isPrivate"
                                       (ngModelChange)="commentObj.isPrivate = !$event"
                                       type="checkbox"
                                       id="isPrivate"
                                       name="isPrivate">
                                <label for="isPrivate"><svg-checked></svg-checked></label>
                                <span>Visible To Resident</span>
                            </label>
                        </div>
                        <div *ngIf="selectedAssigneeType === assigneeType.vendor" class="col-md-12">
                            <label class="img-checkbox">
                                <input [(ngModel)]="commentObj.isPublic"
                                       type="checkbox"
                                       id="isPublic"
                                       name="isPublic">
                                <label for="isPublic"><svg-checked></svg-checked></label>
                                <span>Visible To Vendor</span>
                            </label>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">
                            Submit
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-add-comment-assign-to-modal/service-add-comment-assign-to-modal.component.html